//tip.js
import mobileTip from './tip.vue';
import Vue from 'vue'

export default function mobileTipjs(option) {
    let mobileTipComponent = Vue.extend(mobileTip);
    let instance = new mobileTipComponent().$mount();
    Object.assign(instance, option);
    document.body.appendChild(instance.$el);
    setTimeout(() => {
        if (instance.$el) instance.$el.remove();
    }, 3000)
    Vue.nextTick(() => {
        instance.show = true
            // show 和弹窗组件里的show对应，用于控制显隐
    })
}

['success', 'info', 'error'].forEach(type => {
    mobileTipjs[type] = options => {
        if (typeof options === 'string') {
            options = {
                msg: options
            };
        }
        options.type = type;
        return mobileTipjs(options);
    };

});